<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] {{ $t('location') }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <!-- <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED)"/> -->
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-12">
                            <div class="col-6">
                            <div class="field grid">
                                <label for="Code" class="col-4">{{ $t('code') }}<span style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                    <InputText name="Code" v-model="header.Code" type="text" :placeholder="$t('code')"
                                        v-if="header" :class="{ 'p-invalid': submitted && !header.Code }"
                                        :disabled="mode != this.$FORM_MODE_CREATE"
                                        :readonly="mode != this.$FORM_MODE_CREATE" />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Code && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('code')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Description" class="col-4">{{ $t('description') }}<span
                                        style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                    <InputText name="Description" v-model="header.Description" required="true" type="text"
                                        :placeholder="$t('description')" v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.Description }"
                                        :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || (header && header.Status == this.$APPROVAL_STATUS.APPROVED)" />
                                    <Skeleton v-else-if="!header" />
                                    <small
                                        v-if="header && !header.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('description')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Code_Contractor" class="col-4">{{ $t('code_contractor') }}<span
                                        style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                    <InputText name="Code_Contractor" v-model="header.Code_Contractor" required="true" type="text"
                                        :placeholder="$t('code_contractor')" v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.Code_Contractor }"
                                        :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || (header && header.Status == this.$APPROVAL_STATUS.APPROVED)" />
                                    <Skeleton v-else-if="!header" />
                                    <small
                                        v-if="header && !header.Code_Contractor && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('code_contractor')) }}
                                    </small>
                                </div>
                            </div>
                            <!-- <div class="field grid">
                            </div>

                                <label for="P_Org" class="col-4">{{ $t('Purchase Organization') }}<span
                                        style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                    <InputText name="P_Org" v-model="header.P_Org" required="true" type="text"
                                        :placeholder="$t('Purchase Organization')" v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.P_Org }"
                                        :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || (header && header.Status == this.$APPROVAL_STATUS.APPROVED)" />
                                    <Skeleton v-else-if="!header" />
                                    <small
                                        v-if="header && !header.P_Org && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('P_Org')) }}
                                    </small>
                                </div>
                            </div> -->
                            </div>
                        </div>
                        <div class="col-6">
                                <DataTable v-if="header" :loading="!header" :value="header.PurOrgDetails ? header.PurOrgDetails : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetail()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetail(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Pur_Org" :header="$t('Pur_Org')" Key="Area">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('Pur_Org')" @change="onCellEditComplete(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>                  
                    </div>
                    <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                         <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                 <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
              </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
export default {
    name: "Editor",
    data() {
        return {
            indexName: "LocationIndex",
            url: this.$API_URL + "location/",
            header: null,
            PurOrgDetails: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataChangesLog:this.$dataChangesLogMasterData,
            detailLog : null,
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Name" },
                { field: "Level", header: "Level" },
                { field: "Validity", header: "Validity" },
                { field: "Status", header: "Status" }
            ],

        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.PurOrgDetails = response.data.data.header.PurOrgDetails;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.detailLog = response.data.data.header.DetailLog;
                    if(self.header.Status == this.$APPROVAL_STATUS.APPROVED) self.header.Reason = null;
                })
                .catch(function (error) {
                    alert(error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if(self.header.mode == self.$FORM_MODE_CREATE || self.header.mode == self.$FORM_MODE_DRAFT)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Location " + self.header.Code + " has been Create successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_EDIT || self.header.mode == self.$FORM_MODE_DRAFT_EDIT)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Location " + self.header.Code + " has been Edit successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_DELETE)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Location " + self.header.Code + " has been Delete successfully", life: 3000 } });
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/Location/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            var self = this;
            if (!this.header.Description || !this.header.Code) {
                return;
            }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            var self = this;
            //|| !this.header.Cost_Center
            if (!this.header.Description || !this.header.Code) {
                return;
            }
            if(this.header.Details.length == 0){
                self.showError("Error", "Must have one detail")
                return;
            }   

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.PurOrgDetails;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.PurOrgDetails.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.PurOrgDetails[event.index];
                if (detail.mode == this.$FORM_MODE_CREATE) this.header.PurOrgDetails.splice(this.header.PurOrgDetails.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.PurOrgDetails) {
                let mode = this.header.PurOrgDetails[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.PurOrgDetails[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    }
}
</script>